// extracted by mini-css-extract-plugin
export default {"products":"ty-z","card":"uy-z","oosMessaging":"vy-z"};